// extracted by extract-css-chunks-webpack-plugin
module.exports = {"leftColumn":"_1CynP1","dividerClass":"_24moEj","authorContent":"_2A4lP9","flexDirection":"_28VET4","renderToolTip":"_2ULRgc"};